import { render, staticRenderFns } from "./FeaturedCategoriesWidget.vue?vue&type=template&id=5d690db6"
import script from "./FeaturedCategoriesWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeaturedCategoriesWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FeaturedCategoriesWidget.vue?vue&type=style&index=0&id=5d690db6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports